import {
  IFRAME_PERMISSIONS,
  IFRAME_STYLE,
  type WidgetCallbacks,
  WidgetIframeManager,
  type WidgetSettings,
} from "@swipelux/onramp-core";

export class SwipeluxWidget {
  private container: HTMLElement | null = null;
  private iframe: HTMLIFrameElement | null = null;
  private iframeManager: WidgetIframeManager | null = null;

  constructor(
    private settings: WidgetSettings,
    private callbacks: WidgetCallbacks = {}
  ) {
    if (!settings.apiKey) {
      throw new Error("API key is required");
    }
  }

  public mount(container: HTMLElement) {
    if (this.container) {
      throw new Error("Widget is already mounted");
    }

    this.container = container;
    this.iframe = document.createElement("iframe");
    Object.assign(this.iframe.style, IFRAME_STYLE);
    this.iframe.allow = IFRAME_PERMISSIONS;

    this.iframeManager = new WidgetIframeManager(
      this.iframe,
      this.settings,
      this.callbacks
    );

    this.container.appendChild(this.iframe);
    this.iframeManager.initialize();
  }

  public unmount() {
    if (!this.container || !this.iframe || !this.iframeManager) {
      return;
    }

    this.iframeManager.destroy();
    this.container.removeChild(this.iframe);

    this.container = null;
    this.iframe = null;
    this.iframeManager = null;
  }

  public isMounted() {
    return !!this.container && !!this.iframe && !!this.iframeManager;
  }
}
